import {
  SOBRE_HIGHLIGHT_A,
  SOBRE_HIGHLIGHT_B,
  SOBRE_PARAGRAPHS,
  SOBRE_CHIPS,
  SOBRE_FORMATION,
} from "../content";
import { Reveal } from "../lib/motion";

export const Sobre = () => (
  <section
    id="sobre"
    data-testid="sobre-section"
    className="relative bg-tinta py-20 md:py-32 overflow-hidden"
  >
    <div
      className="absolute -left-20 top-16 w-72 h-16 bg-lima hidden lg:block"
      style={{ clipPath: "polygon(12% 0, 100% 0, 88% 100%, 0 100%)", transform: "rotate(-8deg)" }}
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <Reveal>
        <p data-testid="sobre-label" className="label-caps text-lima mb-10 md:mb-14">
          Quem está por trás do laboratório
        </p>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <Reveal className="lg:col-span-4 flex justify-center lg:justify-start">
          <figure className="relative w-44 h-44 sm:w-56 sm:h-56 lg:w-64 lg:h-64 shrink-0">
            <div
              className="absolute inset-0 translate-x-3 translate-y-3 rounded-full border-2 border-lima"
              aria-hidden="true"
            />
            <img
              data-testid="sobre-founder-photo"
              src="/assets/jacqueline.jpg"
              alt="Jacqueline Canavarro Marquezeti, fundadora e CEO da DealFlow Lab"
              className="relative w-full h-full object-cover object-top rounded-full"
              loading="lazy"
            />
          </figure>
        </Reveal>

        <div className="lg:col-span-8">
          <Reveal>
            <p
              data-testid="sobre-highlight"
              className="headline text-creme text-2xl sm:text-3xl lg:text-4xl"
            >
              {SOBRE_HIGHLIGHT_A}
              <span className="text-lima">{SOBRE_HIGHLIGHT_B}</span>
            </p>
          </Reveal>

          {SOBRE_PARAGRAPHS.map((p, i) => (
            <Reveal key={i} delay={0.05 * (i + 1)}>
              <p
                data-testid={`sobre-paragraph-${i}`}
                className="mt-6 text-muteddark text-base leading-relaxed"
              >
                {i === 0 ? (
                  <>
                    <strong className="text-creme font-semibold">
                      Jacqueline Canavarro Marquezeti
                    </strong>
                    {p.replace("Jacqueline Canavarro Marquezeti", "")}
                  </>
                ) : (
                  p
                )}
              </p>
            </Reveal>
          ))}

          <Reveal delay={0.2}>
            <p
              data-testid="sobre-signature"
              className="mt-8 font-sora font-bold text-creme text-sm tracking-[-0.02em]"
            >
              Jacqueline Canavarro Marquezeti,{" "}
              <span className="text-lima">Fundadora e CEO</span>
            </p>
          </Reveal>

          <Reveal delay={0.25}>
            <p className="label-caps text-muteddark mt-12 mb-5">
              O que a DealFlow Lab domina
            </p>
            <ul data-testid="sobre-chips" className="flex flex-wrap gap-2.5">
              {SOBRE_CHIPS.map((chip) => (
                <li
                  key={chip}
                  className="border border-inkline text-creme/85 font-sora text-xs font-semibold tracking-[-0.01em] px-4 py-2 hover:border-lima hover:text-lima transition-colors duration-150"
                >
                  {chip}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
